/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP or lump sum — which is better?`)
};

const es_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP o suma única — ¿cuál es mejor?`)
};

const de_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP oder Pauschalanlage — was ist besser?`)
};

const nl_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP of eenmalige belegging — welke is beter?`)
};

const fr_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP ou versement unique — lequel est meilleur ?`)
};

const it_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP o investimento forfettario — quale è meglio?`)
};

const pt_br2_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP ou investimento único — qual é melhor?`)
};

const pt_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP ou montante único — qual é melhor?`)
};

const ja_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIPと一括投資 — どちらが良いですか？`)
};

const zh_sip_lumpsum_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SIP还是一次性投资——哪个更好？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_lumpsum_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_lumpsum_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_lumpsum_faq2_q", locale)
	if (locale === "en") return en_sip_lumpsum_faq2_q(inputs)
	if (locale === "es") return es_sip_lumpsum_faq2_q(inputs)
	if (locale === "de") return de_sip_lumpsum_faq2_q(inputs)
	if (locale === "nl") return nl_sip_lumpsum_faq2_q(inputs)
	if (locale === "fr") return fr_sip_lumpsum_faq2_q(inputs)
	if (locale === "it") return it_sip_lumpsum_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_lumpsum_faq2_q(inputs)
	if (locale === "pt") return pt_sip_lumpsum_faq2_q(inputs)
	if (locale === "ja") return ja_sip_lumpsum_faq2_q(inputs)
	return zh_sip_lumpsum_faq2_q(inputs)
};